import { useCallback } from "react";
import { searchShows } from "../services/api";
import { useSearchContext } from "../context/SearchContext";
import type { ApiError, SearchRequest } from "../types";

export function useSearch() {
  const { state, dispatch } = useSearchContext();

  const search = useCallback(
    async (opts?: { artist?: string }) => {
    const artist = opts?.artist ?? state.artist;
    if (!artist || !state.preferences.origin_airport) return;

    const req: SearchRequest = {
      artist,
      origin_airport: state.preferences.origin_airport,
      flexibility_days: state.preferences.flexibility_days,
      nonstop_only: state.preferences.nonstop_only,
      max_stops: state.preferences.max_stops,
      hotel_stars: state.preferences.hotel_stars,
      max_total_budget_cents: state.preferences.max_total_budget_cents,
      max_travel_time_minutes: state.preferences.max_travel_time_minutes,
      date_range_start: state.preferences.date_range_start,
      date_range_end: state.preferences.date_range_end,
    };

    dispatch({ type: "SET_LOADING", loading: true });
    dispatch({ type: "SET_ERROR", error: null });

    try {
      const results = await searchShows(req);
      dispatch({ type: "SET_RESULTS", results });
    } catch (err) {
      dispatch({ type: "SET_ERROR", error: err as ApiError });
    } finally {
      dispatch({ type: "SET_LOADING", loading: false });
    }
    },
    [state.artist, state.preferences, dispatch],
  );

  return {
    search,
    loading: state.loading,
    error: state.error,
    results: state.results,
  };
}
